import type { AnswerResponseDTO, PxQuestion } from './types';

/**
 * Collect the questions that are currently visible, in catalog order, as the
 * submit DTO (UCPWO-378). A question is visible if it is root-level
 * (`parentKey === ''`) or revealed by a selected answer's `relatedQuestions`,
 * transitively. Hidden branches are excluded so no stale answers are submitted;
 * dangling `relatedQuestions` are skipped. See docs/adr/0004.
 */
export const collectVisibleQuestions = (questions: PxQuestion[]): AnswerResponseDTO => {
    const byKey: Record<string, PxQuestion> = {};
    for (const question of questions) byKey[question.key] = question;

    const result: PxQuestion[] = [];
    const seen = new Set<string>();

    const visit = (question: PxQuestion): void => {
        if (seen.has(question.key)) return;
        seen.add(question.key);
        result.push(question);
        for (const answer of question.answers) {
            if (!answer.isSelected) continue;
            for (const relatedKey of answer.relatedQuestions || []) {
                const related = byKey[relatedKey];
                if (related) visit(related);
            }
        }
    };

    questions
        .filter((question) => !question.parentKey)
        .sort((a, b) => a.order - b.order)
        .forEach(visit);

    return result;
};
